import React from 'react';
import {
  Box,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

const toTitleCase = (value) => {
  if (!value) {
    return 'Unknown';
  }
  return value
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const ManufacturingResultsSummary = ({
  formattedRange,
  summaryCards,
  topFailures,
}) => {
  const hasSummaryCards = summaryCards?.length > 0;

  return (
    <Stack spacing={3}>
      {formattedRange && (
        <Typography variant="subtitle2" color="text.secondary">
          Results for {formattedRange.start} - {formattedRange.end}
        </Typography>
      )}

      {hasSummaryCards && (
        <Grid container spacing={2}>
          {summaryCards.map((card) => (
            <Grid key={card.label} size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                elevation={0}
                sx={{
                  p: 1.5,
                  border: '1px solid',
                  borderColor: 'divider',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                }}
              >
                <Typography variant="subtitle2" color="text.secondary">
                  {card.label}
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                  {card.value}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      )}

      {(hasSummaryCards || topFailures?.length > 0) && (
        <Box sx={{ width: '100%', pt: 3 }}>
          <Divider sx={{ width: '100%' }} />
        </Box>
      )}

      <Paper
        elevation={0}
        sx={{
          p: 3,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography variant="h6" gutterBottom>
          Top Failure Types
        </Typography>

        {!topFailures?.length ? (
          <Typography variant="body2" color="text.secondary">
            No failures recorded for the selected range.
          </Typography>
        ) : (
          <Stack spacing={1.5}>
            {topFailures.slice(0, 3).map((failure, index) => (
              <Box
                key={`${failure.failure_type ?? 'unknown'}-${index}`}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                  px: 2,
                  py: 1.5,
                }}
              >
                <Typography variant="body1">
                  {index + 1}. {toTitleCase(failure.failure_type)}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  {(failure.occurrences ?? 0).toLocaleString()} occurrences
                </Typography>
              </Box>
            ))}
          </Stack>
        )}
      </Paper>
    </Stack>
  );
};

export default ManufacturingResultsSummary;
